// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"2403":"129fa6a66cd5c45027bb","9679":"701f774ac04b8c73c9fc"}[chunkId] + ".js";
};